// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"O0-z","inlineTitle":"P0-z","sponsoredAdsWrapper":"Q0-z","marketplaceRecosWrapper":"R0-z"};